<script setup>
import { ref } from 'vue'

const tosDialog = ref(false)

defineExpose({
  tosDialog
})
</script>

<template>
  <v-dialog v-model="tosDialog" max-width="900px" scrollable>
    <v-card class="tos-card">      <div class="tos-header-bg" style="margin-bottom: 50px;">
        <div class="tos-header d-flex align-center px-4">
          <div class="text-h4 font-weight-bold text-white">Terms of Service</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="tosDialog = false" variant="text" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-card-text class="tos-content">
        <div class="tos-intro">
          <div class="intro-icon-container">
            <v-icon size="x-large" color="primary" class="intro-icon">mdi-file-document</v-icon>
          </div>
          <p class="text-body-1">These Terms of Service govern your use of the NIGHTRIDERZ website and services.</p>
        </div>

        <v-row>
          <v-col cols="12">
            <v-card variant="outlined" class="tos-section-card mb-4">
              <v-card-item>
                <template v-slot:prepend>
                  <div class="icon-circle">
                    <v-icon color="white">mdi-handshake</v-icon>
                  </div>
                </template>
                <v-card-title>1. Acceptance of Terms</v-card-title>
              </v-card-item>
              <v-card-text>
                <p>By accessing and using the NIGHTRIDERZ website and services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
              </v-card-text>
            </v-card>

            <v-card variant="outlined" class="tos-section-card mb-4">
              <v-card-item>
                <template v-slot:prepend>
                  <div class="icon-circle">
                    <v-icon color="white">mdi-account-group</v-icon>
                  </div>
                </template>
                <v-card-title>2. User Obligations</v-card-title>
              </v-card-item>
              <v-card-text>
                <p>Users must:</p>
                <ul>
                  <li>Be at least 13 years old to use the service</li>
                  <li>Provide accurate and complete information when creating an account</li>
                  <li>Maintain the security of their account</li>
                  <li>Not use the service for any illegal or unauthorized purpose</li>
                  <li>Not harass, abuse, or harm other users</li>
                </ul>
              </v-card-text>
            </v-card>

            <v-card variant="outlined" class="tos-section-card mb-4">
              <v-card-item>
                <template v-slot:prepend>
                  <div class="icon-circle">
                    <v-icon color="white">mdi-security</v-icon>
                  </div>
                </template>
                <v-card-title>3. Privacy and Data Protection</v-card-title>
              </v-card-item>
              <v-card-text>
                <p>We are committed to protecting your privacy and personal data. Our data collection and processing practices are detailed in our Privacy Policy section of the Legal Notices.</p>
              </v-card-text>
            </v-card>

            <v-card variant="outlined" class="tos-section-card mb-4">
              <v-card-item>
                <template v-slot:prepend>
                  <div class="icon-circle">
                    <v-icon color="white">mdi-cart</v-icon>
                  </div>
                </template>
                <v-card-title>4. Premium Services</v-card-title>
              </v-card-item>
              <v-card-text>
                <p>Premium features are available through an unique payment. By purchasing premium services:</p>
                <ul>
                  <li>You agree to pay the fees as presented</li>
                  <li>No refunds will be provided except as required by law</li>
                </ul>
              </v-card-text>
            </v-card>

            <v-card variant="outlined" class="tos-section-card mb-4">
              <v-card-item>
                <template v-slot:prepend>
                  <div class="icon-circle">
                    <v-icon color="white">mdi-license</v-icon>
                  </div>
                </template>
                <v-card-title>5. Intellectual Property</v-card-title>
              </v-card-item>
              <v-card-text>
                <p>All content on NIGHTRIDERZ, including but not limited to text, graphics, logos, and software, is protected by intellectual property rights. Users may not copy, modify, or distribute this content without explicit permission.</p>
              </v-card-text>
            </v-card>

            <v-card variant="outlined" class="tos-section-card mb-4">
              <v-card-item>
                <template v-slot:prepend>
                  <div class="icon-circle">
                    <v-icon color="white">mdi-scale-balance</v-icon>
                  </div>
                </template>
                <v-card-title>6. Limitation of Liability</v-card-title>
              </v-card-item>
              <v-card-text>
                <p>NIGHTRIDERZ is provided "as is" without any warranties. We will not be liable for any damages arising from the use or inability to use our services.</p>
              </v-card-text>
            </v-card>

            <v-card variant="outlined" class="tos-section-card mb-4">
              <v-card-item>
                <template v-slot:prepend>
                  <div class="icon-circle">
                    <v-icon color="white">mdi-book-edit</v-icon>
                  </div>
                </template>
                <v-card-title>7. Modifications to Terms</v-card-title>
              </v-card-item>
              <v-card-text>
                <p>We reserve the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms.</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="tonal" @click="tosDialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.tos-card {
    border-radius: 24px !important;
    overflow: hidden;
    border: none !important;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5) !important;
    background-color: #151920 !important;
    backdrop-filter: blur(10px);
}

.tos-header-bg {
    background: linear-gradient(135deg, rgba(136, 0, 255, 1) 0%, rgba(0, 65, 255, 1) 100%);
    padding: 40px 30px 80px;
    position: relative;
    overflow: hidden;
}

.tos-header-bg::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background-image: radial-gradient(circle at center, rgba(255,255,255,0.1) 1px, transparent 1px);
    background-size: 20px 20px;
    animation: headerAnimation 15s linear infinite;
}

.close-btn {
    color: white !important;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    backdrop-filter: blur(5px);
    transition: all 0.3s ease;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: rotate(90deg);
}

.tos-header {
    position: relative;
    z-index: 2;
}

.tos-content {
    padding: 32px;
    margin-top: -40px;
    position: relative;
    z-index: 3;
}

.tos-intro {
    text-align: center;
    margin-bottom: 40px;
    padding: 32px;
    background: linear-gradient(to bottom right, #1e2230, #252a3a);
    border-radius: 24px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.05);
}

.intro-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    position: relative;
}

.intro-icon {
    padding: 24px;
    background: linear-gradient(135deg, rgba(136, 0, 255, 0.15), rgba(0, 65, 255, 0.15));
    border-radius: 50%;
    box-shadow: 
        0 0 30px rgba(136, 0, 255, 0.3),
        0 0 60px rgba(0, 65, 255, 0.2);
    animation: pulseIcon 2s ease-in-out infinite;
}

.tos-section-card {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    height: auto;
    border-radius: 20px !important;
    border: 1px solid rgba(255, 255, 255, 0.05) !important;
    background: linear-gradient(135deg, #1a1f2a, #1e2434) !important;
    overflow: hidden;
    position: relative;
}

.tos-section-card::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 2px;
    border-radius: 20px;
    background: linear-gradient(135deg, rgba(136, 0, 255, 0.5), rgba(0, 65, 255, 0.5));
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0;
    transition: opacity 0.4s ease;
}

.tos-section-card:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 
        0 20px 40px rgba(0, 0, 0, 0.3),
        0 0 20px rgba(136, 0, 255, 0.1),
        0 0 40px rgba(0, 65, 255, 0.1) !important;
}

.tos-section-card:hover::before {
    opacity: 1;
}

.icon-circle {
    background: linear-gradient(135deg, rgba(136, 0, 255, 1), rgba(0, 65, 255, 1));
    border-radius: 50%;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 5px 15px rgba(136, 0, 255, 0.3);
}

@keyframes headerAnimation {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

@keyframes pulseIcon {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
}

ul {
    list-style-type: disc;
    padding-left: 20px;
    margin-top: 10px;
}

li {
    margin-bottom: 8px;
    opacity: 0.9;
}
</style>
